import { render, staticRenderFns } from "./ConfirmAssetProblems.vue?vue&type=template&id=fbe5a9be&scoped=true&"
import script from "./ConfirmAssetProblems.vue?vue&type=script&lang=js&"
export * from "./ConfirmAssetProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe5a9be",
  null
  
)

export default component.exports